import "foundation-sites/js/foundation";
import "foundation-sites/js/foundation/foundation.topbar";
import "foundation-sites/js/foundation/foundation.alert";
import "foundation-sites/js/foundation/foundation.equalizer";

$(function() {
    $(document).foundation();
});



// WEBPACK FOOTER //
// ./js/legacy/foundation-init.js